import React from 'react'
import { GeoapifyContext, GeoapifyGeocoderAutocomplete } from '@geoapify/react-geocoder-autocomplete'
import '@geoapify/geocoder-autocomplete/styles/minimal.css'

type GeoapifyGeocoderAutocompleteProps = {
  values: any
  placeholder: string
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const GeoapifyAutocompleteComponent: React.FC<GeoapifyGeocoderAutocompleteProps> = ({
  values,
  handleChange,
  placeholder,
}) => {

  return (
    <GeoapifyContext apiKey={process.env.REACT_APP_GEOCODER_AUTOCOMPLETE_KEY}>
      <GeoapifyGeocoderAutocomplete
        placeSelect={handleChange}
        placeholder={placeholder}
        value={values}
      />
    </GeoapifyContext>
  )
}

export default GeoapifyAutocompleteComponent
